import { DATE_SOURCE_FILTER_OPTIONS } from '@app/shared/constants/data-source.constants';
import { dataSourceFilterBuilder } from '@app/shared/filter-builders/data-source.filter-builder';
import { dataSourceFormatter } from '@app/shared/formatters/data-source.formatter';
import {
  CELL_FILTER,
  CELL_RENDERER,
  DATA_SOURCE,
  DATA_SOURCE_ENUM_OPTIONS,
  DEFAULT_DATA_SOURCE,
  IXVIListColumn,
  TRANSFER_PDF_SUMMARY_NAMES,
  WIDGET_COMPONENT,
} from '@app/shared/types';
import { TIME_FORMATS, WIDGET_FAMILY } from '@config/global-constants';
import { TimeFormats } from '@geniuspos/ui-shared/modules/xdm-shared-components/components/xux-time-picker';
import { ValueFormatterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { CompanyUtilService } from '../company/company-util.service';
import { TRANSFER_STATUS_VALUE } from '@shared/types/enums/transfer-status.enum';
import { COMMON_WARN_MESSAGE_CLASS } from '@shared/constants/common-warn-grid-setting';
import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';

export const DATA_SOURCE_COL = (options: {
  i18nService: XVII18nService;
}): IXVIListColumn => ({
  path: 'source',
  title: options.i18nService.instant(TRANSFER_PDF_SUMMARY_NAMES.Source),
  width: 110,
  filterType: CELL_FILTER.enum,
  filterParams: {
    values: DATE_SOURCE_FILTER_OPTIONS,
    // use this to keep this in filter always
    includeAlways: true,
  },
  filterStringBuilder: dataSourceFilterBuilder,
  valueFormatter: (params) =>
    dataSourceFormatter(params, { i18nService: options.i18nService }),
  cellRenderer: CELL_RENDERER.prepared_string_renderer,
  cellRendererParams: {
    valueToEnumMap: DATA_SOURCE_ENUM_OPTIONS,
  },
  sortable: true,
  defaultView: true,
});

export const getTimeAtColDef = (options: {
  companyService: CompanyUtilService;
  path?: string;
  title?: string;
  i18nService: XVII18nService;
}): IXVIListColumn => ({
  path: options.path ? options.path : 'created_at',
  title: options.i18nService.instant(
    options.title ? options.title : I18n.Common.TimeCreated,
  ),
  filterType: CELL_FILTER.dateTime,
  filterParams: {
    filterOptions: ['equals', 'inRangeDate'],
    default: {
      type: 'inRangeDate',
    },
    timeFormat: TimeFormats.HHMMA,
  },
  valueFormatter: (params: ValueFormatterParams): string => {
    return params?.value
      ? options.companyService.convertUTCDateWithTimeZone(
          get(params, 'value'),
          true,
          TIME_FORMATS.L_LT,
        )
      : '';
  },
  sortable: true,
  defaultView: true,
});

export const transferGeneralFields = (params: {
  i18nService: XVII18nService;
}) => {
  return {
    open_draft_message: {
      widget: WIDGET_COMPONENT.label,
      widgetFamily: WIDGET_FAMILY.LEGACY,
      title: I18n.InfoMessages.TransferRequestStillInDraft,
      show: (doc): boolean =>
        get(doc, 'status') === TRANSFER_STATUS_VALUE.Open &&
        (get(doc, 'source') ===
          params.i18nService.t(DATA_SOURCE_ENUM_OPTIONS[DATA_SOURCE.POS]) ||
          get(doc, 'source') === DATA_SOURCE.POS) &&
        !get(doc, 'is_send'),
      widgetData: {
        itemClass: COMMON_WARN_MESSAGE_CLASS,
      },
    },
    source: {
      title: I18n.Common.Source,
      widget: WIDGET_COMPONENT.input,
      defaultValue: params.i18nService.translate(DEFAULT_DATA_SOURCE),
      disabled: true,
      required: true,
    },
  };
};
